import CallServer from "../../api/CallServerV2"

export async function fetchCommunications (params = {}) {
    return await CallServer({
        params: params,
        endpoint: '/admin/get_communications',
    })
} 

export async function fetchCommunication (communication_id,params = {}) {
    return await CallServer({
        params: {
            communication_id: communication_id,
            ...params
        },
        endpoint: '/admin/get_communication',
    })
} 

export async function fetchCreateCommunication (communication_data) {
    return await CallServer({
        body:communication_data,
        endpoint: '/admin/create_new_communication',
    })
} 

export async function fetchEditCommunication (communication_id,communication_data) {
    return await CallServer({
        params: {
            communication_id: communication_id
        },
        body:communication_data,
        endpoint: '/admin/update_communication',
    })
} 